// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetAsrFilterConfigMultilingualBySourceTypeParam,
    BaseResponseListAsrFilterConfig,
} from '../../../types';

/**
 * getAllMultilingual
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [GET] /asr-filter-config/multilingual/{sourceType}
 * @param sourceType
 */
export function getAsrFilterConfigMultilingualBySourceType(
    options: ApiOptions<GetAsrFilterConfigMultilingualBySourceTypeParam, never> & {
        segments: GetAsrFilterConfigMultilingualBySourceTypeParam;
    }
): Promise<BaseResponseListAsrFilterConfig> {
    return request<never, GetAsrFilterConfigMultilingualBySourceTypeParam, never>(
        '/asr-filter-config/multilingual/{sourceType}',
        {
            ...options,
            method: 'get',
            __$requestCalleeName: 'getAsrFilterConfigMultilingualBySourceType',
        }
    );
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/multilingual/{sourceType}',
        method: 'get',
    },
];
